/* История переходов на главной: известные шаги сайта, без перехода «Назад» на внешний сайт.
   URL сохраняет выбранное действие; разбор поднимает переписку с сервера после перехода.
   «Назад» и «Вперёд» браузера обрабатывает router.ts: чат открывается заново по адресу. */
import { workspaceStore } from "../components/Topbar";
import { navigate } from "../router";
import { currentChatStore } from "../store";

type HistoryState = { pravosvodWorkspace?: { session: string; position: number } } | null;

export type Workspace = {
  show: (code: string | null, title: string, kind: string, from?: string | null, replace?: boolean) => void;
  refresh: () => void;
  rename: (title: string, kind?: string) => void;
  dispose: () => void;
};

export function createWorkspace(): Workspace {
  const params = new URLSearchParams(location.search);
  const initial = currentChatStore.get() ? null : params.get("start");
  const previous = (history.state as HistoryState)?.pravosvodWorkspace;
  const session = previous?.session || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  const key = `pravosvod.navigation.${session}`;
  let position = previous?.position || 0;
  let furthest = position;
  try { furthest = Math.max(position, Number(sessionStorage.getItem(key)) || 0); } catch { /* режим без хранилища */ }
  const state = (n: number) => ({ ...(history.state || {}), pravosvodWorkspace: { session, position: n } });
  const save = () => { try { sessionStorage.setItem(key, String(furthest)); } catch { /* кнопка назад работает и без хранилища */ } };
  if (!previous) {
    if (initial) {
      const url = location.pathname + location.search;
      history.replaceState(state(0), "", "/");
      position = furthest = 1;
      history.pushState(state(1), "", url);
    } else history.replaceState(state(0), "", location.href);
    save();
  }
  // Главный экран — пустой новый чат. «Назад» из любого чата или сценария ведёт на него.
  const onHome = () => !document.body.classList.contains("chatting");
  let shownCode = initial;
  let title = "";
  let kind = "home";
  let disposed = false;   // чат закрыт переходом в другой раздел: адрес и верхнюю строку больше не трогаем

  function refresh() {
    if (disposed) return;
    workspaceStore.set({
      barHidden: onHome() && !shownCode && furthest === 0,
      title, kind,
      backDisabled: onHome(),
      forwardDisabled: position >= furthest,
      onBack: () => { if (!onHome()) navigate("/"); },
      onForward: () => { if (position < furthest) history.forward(); },
    });
  }

  function heading(newTitle: string, newKind: string) {
    title = newTitle;
    kind = newKind;
  }

  function show(code: string | null, newTitle: string, newKind: string, from: string | null = null, replace = false) {
    if (disposed) return;
    shownCode = code;
    const current = new URLSearchParams(location.search);
    if ((current.get("start") || null) !== code || (current.get("from") || null) !== from) {
      const query = new URLSearchParams();
      const chat = currentChatStore.get();
      if (chat) query.set("chat", chat);
      if (code) query.set("start", code);
      if (from) query.set("from", from);
      const url = query.size ? `/?${query}` : "/";
      if (replace) history.replaceState(state(position), "", url);
      else {
        position += 1;
        furthest = position;
        history.pushState(state(position), "", url);
        save();
      }
    }
    heading(newTitle, newKind);
    refresh();
    document.title = code ? `${newTitle} — Правосвод` : "Правосвод — ИИ-помощник юриста";
  }

  show(initial, initial ? "Открываем…" : "Рабочий стол", initial ? "doc" : "home", params.get("from"));
  // rename — заголовок открытого чата без перехода: адрес и история не меняются.
  return {
    show,
    refresh,
    rename: (newTitle: string, newKind = "chat") => { if (!shownCode) { heading(newTitle, newKind); refresh(); } },
    dispose: () => { disposed = true; workspaceStore.set(null); },
  };
}
